import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStockStatus = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/stock-status/list` });

  return data;
};

export default getStockStatus;
